export const safeJsonParse = <T>(value: unknown, fallback: T): T => {
	if (typeof value !== "string") return fallback;

	try {
		return JSON.parse(value) as T;
	} catch {
		return fallback;
	}
};

export const safeJsonParseArray = <T>(value: unknown): T[] => {
	const parsed = safeJsonParse<unknown>(value, []);
	return Array.isArray(parsed) ? (parsed as T[]) : [];
};

export const safeJsonParseObject = <T extends object>(value: unknown, fallback: T): T => {
	const parsed = safeJsonParse<unknown>(value, fallback);
	return parsed !== null && typeof parsed === "object" && !Array.isArray(parsed) ? (parsed as T) : fallback;
};
